module.exports = __webpack_public_path__ + "static/media/v2.f06589de.png";